module.exports = __webpack_public_path__ + "static/media/bkst_site_sell-games_header.127cf87c.jpg";